import { render, staticRenderFns } from "./GallerySettingModal.vue?vue&type=template&id=d1c76bf6&scoped=true"
import script from "./GallerySettingModal.vue?vue&type=script&lang=js"
export * from "./GallerySettingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c76bf6",
  null
  
)

export default component.exports